import React, { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { Button, Flex } from 'antd';
// import get from 'lodash/get';
import Header from '../../components/Header/Header';
import { getToggleLanguage } from '../../api/shareVariable';

import {
  FormattedMessage,
  defineMessages,
  intlShape,
  injectIntl,
} from 'react-intl';

// import { configuration } from '../../configuration';
import '../../index.css';

//Modal
import Modal from 'react-modal';
import '../../assets/stylesheet/modal.css';
import logoImg from '../../assets/images/logo.png';
// import imageSrcIdentity from '../../assets/images/identity.png';

//Action
import { setLanguage, checkID } from '../../actions/user';

class Email extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: 'TH',
      modalIsOpen: false,
      errorMsg: '',
      error: '',
      submiting: false,
      id: this.props.user.id,
      waiting: false,
      // email: get(props.user, 'emails.[0]', ''),
      email: '',
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const { emails } = this.props.user;
    if (emails.length === 0) this.props.history.push('/');
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    if (this.state.waiting === false) this.setState({ modalIsOpen: false });
  }

  setLanguage() {
    const { user } = this.props;
    let newLang = '';
    if (user.language === 'th') newLang = 'en';
    else newLang = 'th';
    this.props.setLanguage(newLang);
  }

  getTextFromDic(msg) {
    const { formatMessage } = this.props.intl;

    return formatMessage(defineMessages({ message: { id: msg } }).message);
  }

  render() {
    const { language, emails } = this.props.user;
    const optionseEmails = emails.map(val => {
      let data = [];
      let objData = {
        value: val,
        label: val,
      };

      var objArr = Object.assign(objData, data[0]);
      return objArr;
    });

    console.log('optionseEmails:', optionseEmails);

    return (
      <div>
        <Header
          next={
            <Button
              className="languageSwicher"
              onClick={() => this.setLanguage()}
            >
              {getToggleLanguage(language)}{' '}
            </Button>
          }
        />
        <Flex justify={'center'} align={'center'}>
          <div className='box'>
            <form className="form-signin" onSubmit={this.onSubmit}>
              <div className="col-md-12 mb-5 text-center img-margin">
                <img
                  alt="Prudentail"
                  src={logoImg}
                  width="250px"
                  className="img-responsive"
                />
              </div>
              <div className="col-md-12 title">
                <FormattedMessage id="app.home.title" />
              </div>
              <div className="col-md-12 appname">
                <span className='red'>PRU</span> HR PORTAL
              </div>
              <div className="col-md-12 mb-30 subtitle">
                <FormattedMessage id="app.home.select_email" />
              </div>

              <div className="col-md-12 mb-15">
                <div className="col-md-8 offset-md-2">
                  <span style={{ color: 'red' }}> {this.state.errorMsg} </span>
                  {/* <select
                    className="form-control form-big"
                    value={this.state.email}
                    onChange={e => {
                      this.setState({ email: e.target.value });
                    }}
                  >
                    {emails.map((email, idx) => (
                      <option value={email} key={idx}>
                        {email}
                      </option>
                    ))}
                  </select> */}
                  <Select
                    className="mt-5 email-selection"
                    options={optionseEmails}
                    // defaultValue={optionseEmails[0]}
                    isClearable
                    placeholder={<FormattedMessage id="app.home.select_email" />}
                    onChange={e => {
                      console.log('onChange e:', e);
                      if (e && e.value) {
                        this.setState({ email: e.value });
                      } else {
                        this.setState({ email: '' });
                      }
                    }}
                  />
                  {/* email: <pre>{JSON.stringify(this.state.email)}</pre> */}
                </div>
              </div>
              <div className="col-md-12 text-center text-only">
                <div className="col-md-8 offset-md-2">
                  <Button shape="round" className='bigButton' type='primary' danger disabled={this.state.submiting} loading={this.state.submiting} htmlType={'submit'}><FormattedMessage id="app.home.next" /></Button>
                  {/* <input
                    className="btn btn-pru btn-block submit bigButton"
                    type="submit"
                    value={this.getTextFromDic('app.home.next')}
                    disabled={this.state.submiting || !this.state.email}
                  /> */}
                </div>
              </div>
              {/* <div className="col-md-12 text-center version">
                <div className="col-md-8 offset-md-2">
                  v. {configuration.version}{' '}
                  {configuration.mode === 'uat' && 'Mode: UAT'}
                </div>
              </div> */}
            </form>
          </div>
        </Flex>

        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className="reactModal"
          contentLabel="Modal View"
        >
          <div className="contrainer">
            <div className="row mb-15">
              <div className="col-12 text-only" style={{ textAlign: 'center' }}>
                {this.state.error}
              </div>
            </div>
            {this.state.error === '' && (
              <div className="row">
                <div
                  className="col-12 text-only"
                  style={{ textAlign: 'center' }}
                >
                  <a href="tel:1621" className="btn btn-block submit bigButton">
                    {'modalButton'}
                  </a>
                </div>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }

  async onSubmit(e) {
    e.preventDefault();
    this.setState({ waiting: false, submiting: true });
    const { id, email } = this.state;
    const response = await this.props.checkID(id, email);
    if (response.status === 'error') {
      if (response.code === 'USER001') {
        this.setState({
          error: this.getTextFromDic('app.home.error_id'),
          errorMsg: '',
        });
      } else {
        this.setState({
          error: 'Something went wrong. Pleas try again.',
          errorMsg: '',
        });
      }
      this.openModal();
      return;
    }
    this.setState({ submiting: false });
    this.props.history.push('/OTP');
  }
}

Email.propTypes = {
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { user } = state;

  return {
    user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    checkID: (...args) => dispatch(checkID(...args)),
    setLanguage: newLang => dispatch(setLanguage(newLang)),
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Email));
